import { RouteConfig } from 'vue-router'
import Siderbar from '../components/sidebar/Sidebar.vue'
import ChildLayout2 from '@/components/ChildLayout2.vue'

const courseDetailRouter: RouteConfig[] = [
  {
    path: ':id',
    components: {
      sidebar: Siderbar,
      default: ChildLayout2
    },
    children: [
      {
        path: '/',
        component: ChildLayout2,
        children: [
          {
            path: '/',
            name: 'course',
            component: () => import('../views/CourseDetail.vue')
          },
          {
            path: 'section/:sectionId',
            name: 'courseChild',
            component: () => import('../views/CourseDetail.vue')
          }
        ]
      },

      {
        path: 'member',
        name: 'courseMember',
        component: () => import('../views/CourseMember.vue')
      },
      {
        path: 'quiz',
        component: ChildLayout2,
        children: [
          {
            path: '/',
            name: 'listQuizzes',
            component: () => import('../views/quiz/ListQuizzes.vue')
          },
          {
            path: ':quizId',
            name: 'quizDetail',
            component: () => import('../views/quiz/QuizDetail.vue')
          },
          {
            path: ':quizId/edit',
            name: 'quizEdit',
            component: () => import('../views/quiz/QuizEdit.vue')
          },
          // {
          //   path: ':quizId/preview',
          //   name: 'quizPreview',
          //   component: () => import('../views/quiz/QuizPreview.vue')
          // },
          {
            path: ':quizId/attempt/:attemptId',
            name: 'quizResult',
            component: () => import('../views/quiz/QuizResult.vue')
          }
        ]
      },
      {
        path: 'files',
        component: ChildLayout2,
        children: [
          {
            path: '/',
            name: 'files',
            component: () => import(`../views/files/ListFiles.vue`)
          }
        ]
      },
      {
        path: 'grades',
        component: ChildLayout2,
        children: [
          {
            path: '/',
            name: 'grades',
            component: () => import(`../views/grades/CourseGrades.vue`)
          }
        ]
      },
      {
        path: 'settings',
        name: 'settings',
        component: ChildLayout2
      }
    ]
  }
]

export default courseDetailRouter
